import { MenuItem, Select } from "@mui/material";
import { useMemo } from "react";

export const SelectColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  console.log("Sdasd", id);
  const options = useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      if (row.values[id]) {
        options.add(row.values[id]);
      }
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <Select
      id="custom-select"
      type="select"
      size="small"
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      sx={{
        width: "100%",
        "& .MuiSelect-select": {
          padding: "6px 14px", // Adjust padding inside select
        },
      }}
    >
      <MenuItem value="">All</MenuItem>
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
};
